import {combineReducers} from 'redux';
import { IUserModel } from './interfaces';

const SET_USER = 'SET_USER';

export const ASetUser = (payload: IUserModel): {
  type: string,
  payload: IUserModel
} => ({
  type: SET_USER,
  payload
});

const initialUserState = {};

const RUser = (state = initialUserState, action: {
  type: string,
  payload: IUserModel
}) => {
  switch (action.type) {
    case SET_USER:
      return {...state, ...action.payload};
    default:
      return state;
  }
};

const SET_OPERATIONS = 'SET_OPERATIONS';

export const ASetOperations = (payload: string[]) => ({
  type: SET_OPERATIONS,
  payload
});

const ROperations = (state = [], action: {
  type: string,
  payload: string[]
}) => {
  switch (action.type) {
    case SET_OPERATIONS:
      return [...action.payload];
    default:
      return [];
  }
};

const rootReducer = combineReducers({
  user: RUser,
  operations: ROperations
});

export default rootReducer;
